// extracted by mini-css-extract-plugin
export default {"description":"RecentNews-module-fc0c918cf3d0ea4c4c4b","date":"RecentNews-module-fe09575c62b05836c540"};